import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { FaUsers } from "react-icons/fa6";
import { PiUserSwitchFill } from "react-icons/pi";
import { FaUserClock, FaUserSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchDashboardData } from "../../Actions/adminActions";
import Chart from "../../Component/MyChart/Chart";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const formatAmount = (value) => parseFloat(value || 0).toFixed(2);

const Dashboard = () => {
  const [currency, setCurrency] = useState([]);
  const dispatch = useDispatch();
  const { dashboardData } = useSelector((state) => state.admin);

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  const fetchIcon = async () => {
    const { data, error } = await apiCall("GET", "/get-company-info");
    if (error) {
      toast.error(error.message || "An error occurred");
    } else {
      setCurrency(data);
    }
  };

  useEffect(() => {
    fetchIcon();
  }, []);

  const statCards = [
    {
      key: "total",
      value: dashboardData?.totalUsers,
      label: "Total Users",
      icon: <FaUsers />,
      variant: "users",
    },
    {
      key: "active",
      value: dashboardData?.activeUsers,
      label: "Active Users",
      icon: <PiUserSwitchFill />,
      variant: "active",
    },
    {
      key: "today",
      value: dashboardData?.todayActiveUsers || "0",
      label: "Today Active Users",
      icon: <FaUserClock />,
      variant: "today",
    },
    {
      key: "blocked",
      value: dashboardData?.blockedUser || "0",
      label: "Blocked Users",
      icon: <FaUserSlash />,
      variant: "blocked",
    },
  ];

  const pendingWithdrawalCount = dashboardData?.countPendingWithdrawals ?? 0;

  return (
    <div className="admin-page home">
      <aside className="home-rail">
        <header className="home-intro">
          <h1>Welcome Back</h1>
          <p>Overview of platform activity and financial metrics</p>
        </header>
        <div className="home-rail-stats">
          {statCards.map((card) => (
            <div
              key={card.key}
              className={`dashboardAdminCard dashboardAdminCard--${card.variant}`}
            >
              <div className="dashboardIcon">
                <i>{card.icon}</i>
              </div>
              <div className="dashboardAdminCard-copy">
                <h3>{card.value ?? "—"}</h3>
                <p>{card.label}</p>
              </div>
            </div>
          ))}
        </div>
      </aside>

      <div className="home-main">
        <div className="home-charts">
          {dashboardData != null && dashboardData ? (
            <Chart
              className="dashboardChart"
              title="FUNDS"
              totalPaymentRequests={dashboardData?.totalPaymentRequests}
              pendingPaymentRequests={dashboardData?.pendingPaymentRequests}
              approvedPaymentRequests={dashboardData?.approvedPaymentRequests}
              rejectedPaymentRequests={dashboardData?.rejectedPaymentRequests}
            />
          ) : null}
          {dashboardData != null && dashboardData ? (
            <Chart
              className="dashboardChart"
              title="WITHDRAWAL"
              totalPaymentRequests={dashboardData?.totalWithdrawals}
              pendingPaymentRequests={dashboardData?.pendingWithdrawals}
              approvedPaymentRequests={dashboardData?.approvedWithdrawals}
              rejectedPaymentRequests={dashboardData?.rejectedWithdrawals}
            />
          ) : null}
        </div>

        <div className="home-boards">
          <div className="dashboardInvestment dashboardWithdrawalPanel">
            <div className="dashboardInvestmentHeading">
              <h3>Withdrawal</h3>
              <Link to="withdraw_controls" className="dashboard-panel-link">
                Manage
              </Link>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Pending requests</h4>
              <p>{pendingWithdrawalCount}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Total amount</h4>
              <p>{formatAmount(dashboardData?.totalWithdrawals)}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Pending amount</h4>
              <p>{formatAmount(dashboardData?.pendingWithdrawals)}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Approved amount</h4>
              <p>{formatAmount(dashboardData?.approvedWithdrawals)}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Today</h4>
              <p>{formatAmount(dashboardData?.todayWithdrawals)}</p>
            </div>
          </div>
          <div className="dashboardInvestment">
            <div className="dashboardInvestmentHeading">
              <h3>Investment</h3>
              <div className="dashboardIcon">{currency?.currency}</div>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Total</h4>
              <p>{formatAmount(dashboardData?.totalInvestment)}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Today</h4>
              <p>{formatAmount(dashboardData?.todayInvestment)}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Yesterday</h4>
              <p>0.00</p>
            </div>
          </div>
          <div className="dashboardInvestment">
            <div className="dashboardInvestmentHeading">
              <h3>Income</h3>
              <div className="dashboardIcon">{currency?.currency}</div>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Total</h4>
              <p>{formatAmount(dashboardData?.totalIncome)}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Today</h4>
              <p>{formatAmount(dashboardData?.todayIncome)}</p>
            </div>
            <div className="dashboardInvestmentContent">
              <h4>Yesterday</h4>
              <p>0.00</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
